export default __webpack_public_path__ + "static/media/44b81db313baeefc.92d88dc55e36e1e48ebc3f0fbb391cc6.svg";